module.exports = __webpack_public_path__ + "media/images/faces/face14-779a5e4e995ec636aebb2ba5a810d706.jpg";